import axios from 'axios';
import React, { useState } from 'react'

const UpdateFlightAirline = ({ setUpdateData1, getTxnData1 }) => {
  console.log({ sssssssss: getTxnData1._id });
  const token = localStorage.getItem('token');
  const [image, setImage] = useState(null)
  const [isImage, setIsImage] = useState(false)
  const [operatorId, setOperatorId] = useState(getTxnData1._id)
  const handleUpdateImage = async () => {
    let message = ''
    try {
      if (image === null || !operatorId) {
        if (image === null) message = 'image is required'
        if (!getTxnData1?._id) message = 'Object id is required try again'
        return alert(message)
      }

      const formData = new FormData()
      formData.append('images', image)
      formData.append('airlineId', operatorId)
      console.log({ formData });
      const response = await axios.patch(`http://localhost:5000/api/admin/payment/update-fligh-airline-image`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (response?.data?.status===201) {
        setUpdateData1('fTable')
      }
      console.log({ revfgxdgd: response?.data });
    } catch (error) {
      console.log({ error });
    }
  }
  return (
    <>
      <div className="row">
        <div className="col-12">
          <h1>Airline Flight Details</h1>
          {JSON.stringify(getTxnData1)}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <table className='table' >
            <thead>
              <tr>
                <th>Airline Name</th>
                <th>Airline Icon</th>
                <th>Airline Code</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{getTxnData1?.airlineName}</td>
                <td><img src={getTxnData1?.airlineImage} alt="" height={50} width={50} /></td>
                <td>{getTxnData1?.airlineCode}</td>
                <td><button onClick={() => setIsImage(!isImage)}>{isImage ? 'Cancel' : 'Changes Images'}</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {
        isImage && <div className="row">
          <div className="col-lg-4">
            <div className="mb-3">

              <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
            </div>
          </div>
          <div className="col-lg-3">
            <button className='btn btn-info' onClick={() => handleUpdateImage()} >Update Image</button>
          </div>
        </div>
      }

    </>
  )
}

export default UpdateFlightAirline
